import { render, staticRenderFns } from "./ChatSystemScore.vue?vue&type=template&id=559a22be&scoped=true&"
import script from "./ChatSystemScore.vue?vue&type=script&lang=js&"
export * from "./ChatSystemScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a22be",
  null
  
)

export default component.exports